(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-product-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function activate(root, tab, focus) {
      root.querySelectorAll('[role="tab"]').forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }

    function init(scope) {
      scope.querySelectorAll('[data-tecmate-finder]').forEach(function (root) {
        if (root.dataset.ready) return;
        root.dataset.ready = '1';
        var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
        tabs.forEach(function (tab, i) {
          tab.addEventListener('click', function () { activate(root, tab, false); });
          tab.addEventListener('keydown', function (e) {
            var next = null;
            if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
            else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
            else if (e.key === 'Home') next = tabs[0];
            else if (e.key === 'End') next = tabs[tabs.length - 1];
            if (next) {
              e.preventDefault();
              activate(root, next, true);
            }
          });
        });
      });
    }

    function run() { init(document); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();

    // Theme editor support
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var panel = e.target.closest('[role="tabpanel"]');
      if (!panel) return;
      var root = panel.closest('[data-tecmate-finder]');
      var tab = root && root.querySelector('[aria-controls="' + panel.id + '"]');
      if (tab) activate(root, tab, false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(scope) {
      scope.querySelectorAll('[data-tm-reviews]').forEach(function (root) {
        if (root.dataset.ready) return;
        root.dataset.ready = '1';

        var track = root.querySelector('[data-tm-reviews-track]');
        var buttons = root.querySelectorAll('.tm-reviews__btn');
        if (!track || buttons.length < 2) return;

        function step() {
          var card = track.querySelector('.tm-reviews__card');
          if (!card) return track.clientWidth;
          var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          // Move by however many whole cards are visible
          var perView = Math.max(1, Math.floor((track.clientWidth + gap) / (card.offsetWidth + gap)));
          return perView * (card.offsetWidth + gap);
        }

        function update() {
          var max = track.scrollWidth - track.clientWidth - 2;
          buttons[0].disabled = track.scrollLeft <= 2;
          buttons[1].disabled = track.scrollLeft >= max;
        }

        buttons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            track.scrollBy({ left: Number(btn.dataset.dir) * step() });
          });
        });

        track.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            track.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * step() });
          }
        });

        track.addEventListener('scroll', update, { passive: true });
        if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
        update();
      });
    }

    function run() { init(document); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();

    // Theme editor support
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      if (e.target.classList && e.target.classList.contains('tm-reviews__card')) {
        e.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-hero-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(scope) {
      var hero = scope.querySelector('[data-tecmate-hero]');
      if (!hero || hero.dataset.ready) return;
      hero.dataset.ready = '1';

      var video = hero.querySelector('.hero-video-wrap video');
      var frame = hero.querySelector('iframe[data-video-src]');
      if (!video && !frame) return;

      // Respect reduced-motion: keep the poster image only
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var btn = hero.querySelector('.hero-video-controls button');
      var stateEl = hero.querySelector('#hero-video-state');
      var labelEl = hero.querySelector('#hero-video-label');
      var playing = true;

      function showButton() {
        hero.classList.add('is-video-loaded');
        if (btn) {
          btn.hidden = false;
          btn.disabled = false;
        }
      }

      function update() {
        if (!btn) return;
        btn.setAttribute('aria-label', playing ? 'Pause background video' : 'Play background video');
        if (stateEl) stateEl.textContent = playing ? 'Ⅱ' : '▶';
        if (labelEl) labelEl.textContent = playing ? 'Pause video' : 'Play video';
      }

      // --- Uploaded Shopify video ---
      if (video) {
        video.muted = true;
        var startVideo = function () {
          var p = video.play();
          if (p && p.then) {
            p.then(showButton).catch(function () { /* autoplay blocked: poster stays */ });
          } else {
            showButton();
          }
        };
        if (btn) {
          btn.addEventListener('click', function () {
            playing = !playing;
            if (playing) video.play(); else video.pause();
            update();
          });
        }
        if (document.readyState === 'complete') startVideo();
        else window.addEventListener('load', startVideo, { once: true });
        return;
      }

      // --- Vimeo ---
      function send(method) {
        if (frame.contentWindow) {
          frame.contentWindow.postMessage(JSON.stringify({ method: method }), 'https://player.vimeo.com');
        }
      }

      frame.addEventListener('load', showButton);

      if (btn) {
        btn.addEventListener('click', function () {
          playing = !playing;
          send(playing ? 'play' : 'pause');
          update();
        });
      }

      // Load the video after the page so it doesn't slow down first paint
      function loadVideo() { frame.src = frame.dataset.videoSrc; }
      if (document.readyState === 'complete') loadVideo();
      else window.addEventListener('load', loadVideo, { once: true });
    }

    function run() { initHero(document); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();

    document.addEventListener('shopify:section:load', function (e) { initHero(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-related-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('tm-related-products')) return;

    class TmRelatedProducts extends HTMLElement {
      connectedCallback() {
        if (this.loaded || !this.dataset.url) return;
        // Wait until the section is close to the screen before loading
        this.observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          this.observer.disconnect();
          this.load();
        }, { rootMargin: '0px 0px 400px 0px' });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      load() {
        this.loaded = true;
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const fresh = html.querySelector('tm-related-products');
            if (fresh && fresh.innerHTML.trim().length) {
              this.innerHTML = fresh.innerHTML;
              const outer = this.closest('.tm-related');
              if (outer) outer.classList.add('is-loaded');
            } else {
              this.hideSection();
            }
          })
          .catch(() => this.hideSection());
      }

      hideSection() {
        if (window.Shopify && window.Shopify.designMode) return;
        const wrapper = this.closest('.shopify-section');
        if (wrapper) wrapper.style.display = 'none';
      }
    }

    customElements.define('tm-related-products', TmRelatedProducts);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seo-grouped-product-grid"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('tecmate-collection-filters')) {

  customElements.define('tecmate-collection-filters', class extends HTMLElement {

    connectedCallback() {

      this.filterFrame = requestAnimationFrame(() => this.initializeFilters());

    }



    disconnectedCallback() {

      cancelAnimationFrame(this.filterFrame);

      if (this.filterEvents) this.filterEvents.abort();

    }



    readFilterValues(item, key) {

      let value;

      try {

        value = JSON.parse(item.getAttribute('data-filter-' + key) || 'null');

      } catch (error) {

        return [];

      }

      const values = Array.isArray(value) ? value : [value];

      return values.flatMap((entry) => {

        if (typeof entry !== 'string' && typeof entry !== 'number') return [];

        // Support pasted bullet-separated text as well as native metafield lists.

        // Keep ranges, commas, and slash-separated labels intact.

        return String(entry).split(/[•|\n]/u).map((text) => text.trim()).filter(Boolean);

      });

    }



    initializeFilters() {

      const toolbar = this.querySelector('[data-filter-toolbar]');

      if (!toolbar) return;

      if (this.filterEvents) this.filterEvents.abort();

      this.filterEvents = new AbortController();

      const eventOptions = { signal: this.filterEvents.signal };

      const fields = ['voltage', 'amperage', 'chemistry'];

      const selects = fields.map((key) => toolbar.querySelector('[data-filter-select="' + key + '"]'));

      const records = Array.from(this.querySelectorAll('[data-filter-product]')).map((item) => {

        const terms = {};

        fields.forEach((key) => { terms[key] = this.readFilterValues(item, key); });

        return { item, id: item.dataset.productId, terms };

      });

      const totalProducts = new Set(records.map((record) => record.id)).size;

      const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

      const normalize = (text) => text.toLocaleLowerCase();



      selects.forEach((select, index) => {

        const key = fields[index];

        const values = new Map();

        records.forEach((record) => record.terms[key].forEach((text) => {

          const value = normalize(text);

          if (!values.has(value)) values.set(value, text);

        }));

        while (select.options.length > 1) select.remove(1);

        const sorted = Array.from(values.entries()).sort((a, b) => {

          if (key !== 'chemistry') {

            const first = parseFloat(a[1]);

            const second = parseFloat(b[1]);

            if (Number.isFinite(first) && Number.isFinite(second) && first !== second) return first - second;

          }

          return collator.compare(a[1], b[1]);

        });

        sorted.forEach(([value, label]) => select.add(new Option(label, value)));

        select.closest('[data-filter-field]').hidden = values.size === 0;

              const field = select.closest('[data-filter-field]');



      // Rebuild chips when the section initializes.

      field.querySelector('[data-filter-chips]')?.remove();



      const chips = document.createElement('div');

      chips.className = 'collection-grid-filters__chips';

      chips.setAttribute('data-filter-chips', '');

      chips.setAttribute('role', 'group');

      chips.setAttribute(

        'aria-label',

        field.querySelector('label').textContent.trim()

      );



      Array.from(select.options).forEach((option) => {

        const button = document.createElement('button');



        button.type = 'button';

        button.className = 'collection-grid-filters__chip';

        button.dataset.filterValue = option.value;

        button.textContent = option.textContent;

        button.setAttribute(

          'aria-pressed',

          String(select.value === option.value)

        );



        button.addEventListener('click', () => {

          select.value = option.value;

          select.dispatchEvent(

            new Event('change', { bubbles: true })

          );

        }, eventOptions);



        chips.append(button);

      });



      field.append(chips);



      // Keep the select as the existing filter's internal value.

      select.hidden = true;

      field.querySelector('label').removeAttribute('for');

      });



      const hasOptions = selects.some((select) => select.options.length > 1);

      toolbar.hidden = !hasOptions;

      const setupMessage = this.querySelector('[data-filter-setup-message]');

      if (setupMessage) setupMessage.hidden = hasOptions;

      if (!hasOptions) return;



      const groups = Array.from(this.querySelectorAll('.industrial-product-group'));

      const navigation = this.querySelector('[data-filter-navigation]');

      const links = navigation ? Array.from(navigation.querySelectorAll('a[href^="#"]')) : [];

      const empty = this.querySelector('[data-filter-empty]');

      const status = toolbar.querySelector('[data-filter-status]');

      const clear = toolbar.querySelector('[data-filter-clear]');

      const update = () => {

        const selected = selects.map((select) => select.value);

              // Update selected styling, including after Clear filters.

      selects.forEach((select) => {

        const buttons = select

          .closest('[data-filter-field]')

          .querySelectorAll('[data-filter-value]');



        buttons.forEach((button) => {

          button.setAttribute(

            'aria-pressed',

            String(button.dataset.filterValue === select.value)

          );

        });

      });

        const active = selected.some(Boolean);

        const matched = new Set();

        records.forEach((record) => {

          const visible = fields.every((key, index) => !selected[index] || record.terms[key].some((term) => normalize(term) === selected[index]));

          record.item.hidden = !visible;

          if (visible) matched.add(record.id);

        });



        let firstVisible = true;

        groups.forEach((group) => {

          const items = Array.from(group.querySelectorAll('[data-filter-product]'));

          const visibleCount = items.filter((item) => !item.hidden).length;

          // Preserve empty-row guidance in the theme editor until a filter is selected.

          group.hidden = active ? visibleCount === 0 : false;

          group.classList.toggle('is-first-visible', !group.hidden && firstVisible);

          if (!group.hidden) firstVisible = false;

          const count = group.querySelector('[data-filter-row-count]');

          if (count) count.textContent = visibleCount + (visibleCount === 1 ? ' product' : ' products');

          links.filter((link) => link.hash === '#' + group.id).forEach((link) => {

            link.closest('li').hidden = group.hidden;

          });

        });

        if (navigation) navigation.hidden = links.every((link) => link.closest('li').hidden);

        if (empty) empty.hidden = !active || matched.size > 0;

        clear.disabled = !active;

        status.textContent = matched.size + ' of ' + totalProducts + (totalProducts === 1 ? ' product' : ' products');

      };

      selects.forEach((select) => select.addEventListener('change', update, eventOptions));

      clear.addEventListener('click', () => {

        selects.forEach((select) => { select.value = ''; });

        update();

      }, eventOptions);

      update();

    }

  });

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tecmate-custom-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var toggle = header.querySelector('.menu-toggle');
    var nav = header.querySelector('#primary-nav');
    var dropdowns = header.querySelectorAll('.site-nav details');
    var wrapper = header.closest('.shopify-section');

    // Mobile menu toggle — adds .is-open to the nav (match this class in your CSS)
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        toggle.setAttribute('aria-label', open ? 'Open navigation' : 'Close navigation');
        nav.classList.toggle('is-open', !open);
      });
    }

    // Only one dropdown open at a time
    dropdowns.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        dropdowns.forEach(function (other) { if (other !== d) other.open = false; });
      });
    });

    // Close dropdowns on outside click or Escape
    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) dropdowns.forEach(function (d) { d.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') dropdowns.forEach(function (d) { d.open = false; });
    });

    // Search pop-up (the icon still links to /search if JavaScript is off)
    var searchToggle = header.querySelector('.search-toggle');
    var searchDialog = document.getElementById('HeaderSearch');
    if (searchToggle && searchDialog && typeof searchDialog.showModal === 'function') {
      var searchInput = searchDialog.querySelector('.tm-search__input');
      var resultsBox = searchDialog.querySelector('[data-search-results]');
      var resultsList = searchDialog.querySelector('[data-search-list]');
      var allLink = searchDialog.querySelector('[data-search-all]');
      var allText = searchDialog.querySelector('[data-search-all-text]');
      var emptyMsg = searchDialog.querySelector('[data-search-empty]');
      var statusMsg = document.getElementById('HeaderSearchStatus');
      var suggestUrl = searchDialog.getAttribute('data-suggest-url');
      var searchUrl = searchToggle.getAttribute('href');
      var currency = searchDialog.getAttribute('data-currency') || 'USD';
      var locale = searchDialog.getAttribute('data-locale') || 'en';
      var timer = null;
      var controller = null;

      var formatPrice = function (value) {
        var amount = parseFloat(value);
        if (isNaN(amount)) return '';
        try {
          return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(amount);
        } catch (err) {
          return '$' + amount.toFixed(2);
        }
      };

      var sizedImage = function (src) {
        if (!src) return '';
        try {
          var u = new URL(src, window.location.origin);
          u.searchParams.set('width', '160');
          return u.toString();
        } catch (err) {
          return src;
        }
      };

      var clearResults = function () {
        resultsList.innerHTML = '';
        resultsBox.hidden = true;
        emptyMsg.hidden = true;
        statusMsg.textContent = '';
      };

      var render = function (query, products) {
        resultsList.innerHTML = '';
        var allHref = searchUrl + '?q=' + encodeURIComponent(query) + '&options%5Bprefix%5D=last';
        allLink.href = allHref;
        allText.textContent = 'View all results for “' + query + '”';

        if (!products.length) {
          resultsBox.hidden = true;
          emptyMsg.hidden = false;
          emptyMsg.textContent = 'No products found for “' + query + '”. Press Enter to search the whole store.';
          statusMsg.textContent = 'No products found';
          return;
        }

        products.forEach(function (p) {
          var li = document.createElement('li');
          li.className = 'tm-search__item';
          var a = document.createElement('a');
          a.href = p.url;

          var thumb = document.createElement('span');
          thumb.className = 'tm-search__thumb';
          var imgSrc = (p.featured_image && p.featured_image.url) || p.image;
          if (imgSrc) {
            var img = document.createElement('img');
            img.src = sizedImage(imgSrc);
            img.alt = '';
            img.loading = 'lazy';
            img.width = 56;
            img.height = 56;
            thumb.appendChild(img);
          }

          var text = document.createElement('span');
          text.className = 'tm-search__text';
          var title = document.createElement('span');
          title.className = 'tm-search__title';
          title.textContent = p.title;
          var price = document.createElement('span');
          price.className = 'tm-search__price';
          price.textContent = p.available === false ? 'Sold out' : formatPrice(p.price);
          text.appendChild(title);
          text.appendChild(price);

          a.appendChild(thumb);
          a.appendChild(text);
          li.appendChild(a);
          resultsList.appendChild(li);
        });

        emptyMsg.hidden = true;
        resultsBox.hidden = false;
        statusMsg.textContent = products.length + (products.length === 1 ? ' product found' : ' products found');
      };

      var suggest = function (query) {
        if (controller) controller.abort();
        controller = new AbortController();
        var url = suggestUrl + '?q=' + encodeURIComponent(query) +
          '&resources%5Btype%5D=product&resources%5Blimit%5D=6' +
          '&resources%5Boptions%5D%5Bunavailable_products%5D=last';
        fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function (data) {
            var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            render(query, products);
          })
          .catch(function (err) { if (err.name !== 'AbortError') clearResults(); });
      };

      searchInput.addEventListener('input', function () {
        var query = searchInput.value.trim();
        clearTimeout(timer);
        if (query.length < 2) { if (controller) controller.abort(); clearResults(); return; }
        timer = setTimeout(function () { suggest(query); }, 200);
      });

      searchToggle.addEventListener('click', function (e) {
        e.preventDefault();
        dropdowns.forEach(function (d) { d.open = false; });
        searchDialog.showModal();
        document.body.classList.add('tm-search-open');
        searchInput.focus();
        if (searchInput.value.trim().length >= 2) searchInput.select();
      });

      searchDialog.querySelector('[data-search-close]').addEventListener('click', function () { searchDialog.close(); });

      // Escape closes in one press (a search field would otherwise just clear itself first)
      searchDialog.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); searchDialog.close(); }
      });

      // Click on the dimmed area closes it
      searchDialog.addEventListener('click', function (e) {
        if (e.target === searchDialog) searchDialog.close();
      });

      searchDialog.addEventListener('close', function () {
        document.body.classList.remove('tm-search-open');
        searchToggle.focus();
      });
    }

    // Sticky header: shadow once scrolled; in "scroll up" mode, hide while
    // scrolling down and slide back in as soon as the visitor scrolls up
    var mode = header.getAttribute('data-sticky');
    if (wrapper && mode !== 'off') {
      var ticking = false;
      var lastY = window.scrollY;
      var menuOpen = function () {
        return (nav && nav.classList.contains('is-open')) ||
          Array.prototype.some.call(dropdowns, function (d) { return d.open; });
      };
      var update = function () {
        var y = Math.max(window.scrollY, 0);
        var delta = y - lastY;
        wrapper.classList.toggle('is-scrolled', y > 4);

        if (mode === 'scroll_up') {
          if (y <= header.offsetHeight || menuOpen()) {
            wrapper.classList.remove('is-hidden');
          } else if (delta > 6) {
            wrapper.classList.add('is-hidden');
          } else if (delta < -6) {
            wrapper.classList.remove('is-hidden');
          }
        }

        if (Math.abs(delta) > 6) lastY = y;
        ticking = false;
      };

      // Keyboard users tabbing into the header always see it
      header.addEventListener('focusin', function () { wrapper.classList.remove('is-hidden'); });
      window.addEventListener('scroll', function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      }, { passive: true });
      update();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
